import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize } = redesignTheme;

export const useOtpInputStyles = makeStyles(() => ({
  otpInputs: {
    display: 'flex',
    gap: 20,
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  otpCell: {
    position: 'relative',
    width: 48,
    height: 40,
    borderRadius: 4,
    backgroundColor: 'rgba(122, 101, 85, 0.16)',
    flexShrink: 0,
    transition: 'box-shadow 0.2s ease',
    '&:focus-within': {
      boxShadow: '0 0 0 2px rgba(0, 10, 140, 0.15)',
    },
    '@media (max-width: 480px)': {
      width: 40,
    },
  },
  otpCellEmpty: {
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'rgba(122, 101, 85, 0.5)',
      transform: 'translate(-50%, -50%)',
      pointerEvents: 'none',
    },
  },
  otpCellError: {
    boxShadow: `0 0 0 1px ${colors.error}`,
    '&:focus-within': {
      boxShadow: '0 0 0 2px rgba(230, 60, 60, 0.2)',
    },
  },
  otpInput: {
    width: '100%',
    height: '100%',
    border: 'none',
    borderRadius: 4,
    backgroundColor: 'transparent',
    textAlign: 'center',
    fontSize: 20,
    fontFamily: fonts.gothicSemiBold,
    color: colors.primary,
    outline: 'none',
    caretColor: colors.primary,
    '@media (max-width: 480px)': {
      fontSize: 18,
    },
  },
}));
